import { inject, observer } from 'mobx-react';
import * as React from 'react';
import InternetCalculatorStore from '../../stores/InternetCalculatorStore';
import SuggestInternetSpeedRow from './SuggestInternetSpeedRow';

interface InternetsInfoProps {
  calculatorKey: string;
  internetCalculatorStore?: InternetCalculatorStore;
}

const InternetsInfo = (props: InternetsInfoProps): JSX.Element => {
  const { calculatorKey, internetCalculatorStore } = props;

  if (internetCalculatorStore.hasOnlyPlannedNetwork(calculatorKey) || internetCalculatorStore.noResults(calculatorKey)) {
    return null;
  }

  return <SuggestInternetSpeedRow calculatorKey={calculatorKey} />;
};

export default inject('internetCalculatorStore')(observer(InternetsInfo));
